import React, { useCallback, useState } from 'react'

import { useFrotista } from 'modules/user/hooks/useFrotista'
import { MdArrowDropDown, MdSettings } from 'react-icons/md'
import { FaSignOutAlt } from 'react-icons/fa'

import {
  Container,
  SelectedCnpj,
  ButtonFrotista,
  SelectedFrotista,
  ContainerCnpj,
  ButtonCnpj,
  ButtonCnpjFrotista,
  ContainerHeader,
  ContainerSelectedCnpj,
  SelectedCnpjRazSoc,
} from './styles'
import { colors } from 'shared/styles/colors'
import Frotista from 'modules/user/domain/entities/Frotista'
import { useAuth } from 'modules/auth/hooks/auth'
import { cnpjMask } from 'shared/utils/formatters'
import { useHistory } from 'react-router'

const SelectFrotista: React.FC = () => {
  const { setFrotista, setFrotistaId, frotistas, frotista } = useFrotista()
  const { signOut, user, perfil } = useAuth()
  const [openCnpj, setOpenCnpj] = useState(false)
  const history = useHistory()

  const handleOpenCnpj = useCallback(() => {
    setOpenCnpj(state => !state)
  }, [])

  const handleClearFilter = useCallback(() => {
    setFrotistaId(null)
    setFrotista({} as Frotista)

    setOpenCnpj(state => !state)
  }, [setFrotista, setFrotistaId])

  const handleSelectFrotista = useCallback(
    (frotista: Frotista) => {
      setFrotistaId(frotista.id)
      setFrotista(frotista)

      setOpenCnpj(state => !state)
    },
    [setFrotista, setFrotistaId],
  )

  const handleManageAccount = useCallback(() => {
    setOpenCnpj(state => !state)
    history.push('/gerenciar-conta')
  }, [history])

  return (
    <ContainerHeader>
      <Container>
        <ContainerSelectedCnpj>
          {frotista.cnpj && (
            <SelectedCnpjRazSoc>{frotista.email}</SelectedCnpjRazSoc>
          )}
          <SelectedCnpj>
            {frotista.cnpj ? cnpjMask(frotista.cnpj) : "Todos os CNPJ's"}
          </SelectedCnpj>
        </ContainerSelectedCnpj>

        <ButtonFrotista onClick={handleOpenCnpj}>
          {user && (
            <SelectedFrotista>
              {user.substr(0, 2).toUpperCase()}
            </SelectedFrotista>
          )}
          <MdArrowDropDown color={colors.white} />
        </ButtonFrotista>

        {openCnpj && (
          <ContainerCnpj>
            <ButtonCnpj onClick={handleClearFilter}>
              {"Ver todos os CNPJ's"}
            </ButtonCnpj>
            <span>
              {frotistas && frotistas.length
                ? 'Ou visualizar'
                : 'Nenhum CNPJ vinculado'}
            </span>
            <div>
              {frotistas.map(frotista => (
                <ButtonCnpjFrotista
                  className="cnpj-frotista"
                  onClick={() => handleSelectFrotista(frotista)}
                  key={frotista.id}
                >
                  {cnpjMask(frotista.cnpj)}
                </ButtonCnpjFrotista>
              ))}
            </div>
            {/* Liberado somente para suporte TMOV para análise de segurança */}
            {user === 'suporte.ti@tmov.com.br' && (
              <div>
                <button onClick={handleManageAccount}>
                  <MdSettings />
                  <span>Gerenciar conta</span>
                </button>
              </div>
            )}
            <div>
              <button
                onClick={() => {
                  signOut()
                  handleClearFilter()
                }}
              >
                <FaSignOutAlt />
                <span>Sair</span>
              </button>
            </div>
          </ContainerCnpj>
        )}
      </Container>
    </ContainerHeader>
  )
}

export default SelectFrotista
